import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretUp, faCaretDown } from '@fortawesome/free-solid-svg-icons'
import { Link } from 'react-router-dom';

export default function ShowMore(props) {
  const { isVisible, isActive, onClick } = props;

  // Provide onClick event and prevent defoult button action
  const submitButton = (e) => {
    e.preventDefault()
    onClick()
  }

  if (!isVisible) {
    return ''
  }

  return (
    <div className="lox-show-more column is-full py-2">
      <Link
        href="ShowMore"
        onClick={(e) => submitButton(e)}
        className="is-size-7 has-text-link"
      >
        {
          isActive
            ? 'Show Less '
            : 'Show More '
        }
        {
          isActive
            ? <FontAwesomeIcon icon={faCaretUp} className="px-1" />
            : <FontAwesomeIcon icon={faCaretDown} className="px-1" />
        }
      </Link>
    </div>
  )
}
